
import React from 'react';
import { FlowRender } from "../flow-render";
import { Name } from "../prm/name";
import { Text } from "../prm/text";
import { GreyBox } from "../../client/funcs/utils";
import faker from 'faker';
import {has_joint_role, role_titles} from "../onboarding-utils";
import { AllNames, CREATE_SOURCE_OF_FUNDS_PRM } from "./shared-prms";

const title = "What do you expect will be the source of funds for this account?";

const role_0_source_of_funds = CREATE_SOURCE_OF_FUNDS_PRM(AllNames.ROLE_0_SOURCE_OF_FUNDS);
const role_0_future_source = CREATE_SOURCE_OF_FUNDS_PRM(new Name("role_0_future_source"));
const role_1_source_of_funds = CREATE_SOURCE_OF_FUNDS_PRM(AllNames.ROLE_1_SOURCE_OF_FUNDS);
const role_1_future_source = CREATE_SOURCE_OF_FUNDS_PRM(new Name("role_1_future_source"));

const role_0_other_source = new Text(AllNames.ROLE_0_OTHER_SOURCE);
const role_0_other_future_source = new Text(new Name("role_0_other_future_source"));
const role_1_other_source = new Text(AllNames.ROLE_1_OTHER_SOURCE);
const role_1_other_future_source = new Text(new Name("role_1_other_future_source"));
const totalSourceOfFundOptions = 7;

class SourceOfFunds extends FlowRender {

  constructor(index) {
    super(index, [
      role_0_source_of_funds,
      role_0_other_source,
      role_0_future_source,
      role_0_other_future_source,
      role_1_source_of_funds,
      role_1_other_source,
      role_1_future_source,
      role_1_other_future_source,
    ]);

    role_0_source_of_funds.onChangeCallback = this.onChange;
    role_1_source_of_funds.onChangeCallback = this.onChange;
    role_0_other_source.onChangeCallback = this.onChange;
    role_1_other_source.onChangeCallback = this.onChange;
    role_0_other_source.onAction = this.onTextEdit;
    role_1_other_source.onAction = this.onTextEdit;
    this.url = "source_of_funds";
  }

  onTextEdit = component => {
    const newState = Object.assign({}, component.state);
    this.onChange(component, newState);
    component.setState(newState);
  };

  onChange = (component, newState) => {

    const process = (source_prm, other_prm, future_prm, future_other_prm) => {
      const is_other_clicked = source_prm.isSelected(newState, totalSourceOfFundOptions);
      other_prm.setDisabled(newState, !is_other_clicked);
      const val = source_prm.getValue(newState, true);
      future_prm.clear(newState);
      if (val) {
        future_prm.setValues(newState, [val], true);
      }
      future_other_prm.setValue(newState, role_0_other_source.getValue(newState));
    }

    process(
      role_0_source_of_funds, role_0_other_source,
      role_0_future_source, role_0_other_future_source);
    process(
      role_1_source_of_funds, role_1_other_source,
      role_1_future_source, role_1_other_future_source);
  };

  canNavigateNext(component) {
    const highlight_rects = [];
    const has_joint = has_joint_role(component.getOnboardingData());
    const filled_0 = role_0_source_of_funds.isFilledElseHighlight(
      component.state, highlight_rects);
    const filled_1 = !has_joint || role_1_source_of_funds.isFilledElseHighlight(
      component.state, highlight_rects);

    if (filled_0 && filled_1) {
      const is_other_0 = role_0_source_of_funds.isSelected(component.state, totalSourceOfFundOptions);
      const is_blank_0 = role_0_other_source.isBlank(component.state);
      const is_other_1 = role_1_source_of_funds.isSelected(component.state, totalSourceOfFundOptions);
      const is_blank_1 = role_1_other_source.isBlank(component.state);

      if (is_other_0 && is_blank_0) {
        highlight_rects.push(role_0_other_source.getHighlightRect());
      }
      if (is_other_1 && is_blank_1) {
        highlight_rects.push(role_1_other_source.getHighlightRect());
      }

      const is_0_ok = !is_other_0 || (is_other_0 && !is_blank_0);
      const is_1_ok = !has_joint || (has_joint && (!is_other_1 || (is_other_1 && !is_blank_1)));

      if (is_0_ok && is_1_ok) {
        const index = component.getOnboardingIndex();
        const num_roles = role_titles(component.getOnboardingData()).length;
        return component.getRootUrl() +
          // If we're the base account, or if this current account requires multiple roles
          ((index === 0 || num_roles === 2)
            ? "/employment" : "/authorization_0");
      }
    }

    component.setState({ highlight_rects });
    return null;
  }

  setRandomValues(state, component) {
    super.setRandomValues(state);
    const max_index = role_0_source_of_funds.buttonList.length - 2;
    const index = faker.random.number({min: 0, max: max_index });
    const id = role_0_source_of_funds.buttonList[index].id.split("|")[1];

    role_0_source_of_funds.clear(state);
    role_0_source_of_funds.setValues(state, [id], true);
  }

  dumpCheckbox = (component, prm_index, index) => {
    const is_other = index === totalSourceOfFundOptions;
    const radio_prm = [role_0_source_of_funds, role_1_source_of_funds][prm_index];
    const other_prm = [ role_0_other_source, role_1_other_source][prm_index];

    const inputStyle = {
      width: "100%",
    };

    const container_style = {
      display: "flex",
      flexWrap: "wrap",
      marginBottom: "1rem",
      alignItems: "center",
    }

    // const label_style = {
    //   marginLeft: "1rem",
    // }

    return (
      <div key={index} style={container_style}>
        {/* <div>
          { radio_prm.renderCheckbox(index, component) }
        </div>
        <div>
          { radio_prm.renderLabel(index, component.state, label_style) }
        </div> */}
        {radio_prm.renderRadioLabel(index, component)}
        <div style={{flex: "1", marginLeft: "1rem", marginRight: "1rem", boxSizing: "border-box"}}>
          { is_other && other_prm.renderInput(component, inputStyle) }
        </div>

      </div>
    )
  };

  render = component => {

    const has_joint = has_joint_role(component.getOnboardingData());

    const container_style = {
      width: has_joint ? "60%" : "50%",
      margin: "auto",
    };
    const count = [...Array(role_0_source_of_funds.buttonList.length).keys()];
    const onboarding = component.getOnboardingData();
    const primary_name = onboarding.role_0_first_name + " " + onboarding.role_0_last_name;
    const joint_name = has_joint
      ? onboarding.role_1_first_name + " " + onboarding.role_1_last_name
      : "";

    const box = !has_joint ?
      (<div>
        <GreyBox>
          { count.map(index => this.dumpCheckbox(component, 0, index)) }
        </GreyBox>
      </div>) :
      (
        <div style={{display: "flex"}}>
          <div style={{display: "flex: 1"}} align={"center"}>
            <div>{primary_name}</div>
            <GreyBox>
              { count.map(index => this.dumpCheckbox(component, 0, index)) }
            </GreyBox>
          </div>
          <div style={{width: "1rem"}}/>
          <div style={{display: "flex: 1"}} align={"center"}>
            <div>{joint_name}</div>
            <GreyBox>
              { count.map(index => this.dumpCheckbox(component, 1, index)) }
            </GreyBox>
          </div>

        </div>
      )
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Source of Funds", "50%", "952141939") }
        { this.renderProgress(component) }
        <section style={{paddingTop: "1rem"}} className={"section"}>
          <div className="source-of-funds-container-responsive" style={container_style}>

            <div style={{fontSize: "1.5rem"}}>{title}</div>
            <div style={{height: "1rem"}}/>
            { box }
          </div>
          { this.renderNextButtonRow(component, true) }
        </section>
      </div>
    )
  }
}


/**
 * If you need to set the source-of-funds data without visiting the
 * page, use this to calc the onboarding data.
 *
 * @param id {String} id to set.
 * @param other_source {String}
 */
const set_source_of_funds = (id, other_source) => {

  const state = {};
  role_0_source_of_funds.initState(state);
  role_0_future_source.initState(state);
  role_0_other_source.initState(state);
  role_0_other_future_source.initState(state);
  role_0_source_of_funds.setValues(state, [id], true);
  role_0_future_source.setValues(state, [id], true);
  if (id === "other") {
    role_0_other_source.setValue(state, other_source);
    role_0_other_future_source.setValue(state, other_source);
  } else {
    role_0_other_source.setValue(state, "");
    role_0_other_future_source.setValue(state, "");
  }
  return {
    ...role_0_source_of_funds.saveToState(state),
    ...role_0_future_source.saveToState(state),
    ...role_0_other_source.saveToState(state),
    ...role_0_other_future_source.saveToState(state),
  }
}

export { SourceOfFunds, role_0_source_of_funds, set_source_of_funds };
